import { Controller } from '@hotwired/stimulus';

// The value is rendered as char codes so it is not scraped straight from the markup
export default class extends Controller {
  static targets = ['button', 'number'];

  show() {
    this.buttonTarget.classList.add('hidden');

    this.numberTargets.forEach((item) => {
      item.textContent = this.#decrypt(item.dataset.value);

      delete item.dataset.value;

      item.classList.remove('hidden');
    });
  }

  #decrypt(bytes) {
    return String.fromCharCode(...bytes.split(','));
  }
}
